import React from 'react'

const ExtraComp = () => {
  return (
    <>
      <div className="relative text-center py-16 px-10 bg-transparent backdrop-blur-xl">
        <p className="relative text-3xl font-medium text-[#364655]">
          Boost your business productivity and efficiency with <br />
          EasyGST - the best choice for GST compliance!
        </p>
        <p className="relative text-3xl font-medium text-[#364655] mb-10">
          Join with Thousands of Tax Professionals & Business Leaders who trust
          EasyGST Software
        </p>
        <div className='mt-5'>
          <a
            href="https://www.easyofficesoftware.com/public/demo/demo/EasyGSTDemoSetup.exe"
            rel="noreferrer"
            target="_blank"
            className="ml-5 sm:py-4 py-2 px-7 sm:px-20 rounded-lg bg-[#7decc6] text-black text-3xl font-bold shadow duration-150 hover:text-white hover:bg-[#51a589]"
          >
            Download Demo
          </a>
        </div>
      </div>
    </>
  );
}

export default ExtraComp;